import { Logo } from '@seek/logo';
import { Box } from 'braid-design-system';

import type { LogoProperties } from 'src/types';

const brand = 'jobsdb';
const defaultVariant = 'standard';
const defaultSizeType = 'standard';

export const JDBBrandLogo = (logoProps: LogoProperties) => (
  <Box style={logoProps} data-testid="jobsdb-logo">
    <Logo
      variant={defaultVariant}
      brand={brand}
      size={logoProps?.height ? 'fill' : defaultSizeType}
    />
  </Box>
);
